import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class FieldInformation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
        };

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
    }


    close() {
        this.setState({ ...this.state, showModal: false });
    }

    open() {
        this.setState({ ...this.state, showModal: true });
    }

    render() {
        const { info, title } = this.props;
        return (
            <span>
                <a onClick={this.open}><i className="fa fa-question-circle fa-lg" aria-hidden="true"></i></a>
                <Modal className="custom-modal" show={this.state.showModal} onHide={this.close} bsSize="large">
                    <Modal.Header>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body dangerouslySetInnerHTML={{__html: info}}>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            type="submit"
                            bsStyle="success"
                            onClick={this.close}
                        >
                            Entendido
                        </Button>
                    </Modal.Footer>
                </Modal>
            </span>

        );
    }
}

export default FieldInformation;


/** WEBPACK FOOTER **
 ** ./src/components/FieldInformation.js
 **/